'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hero = function (_Phaser$Sprite) {
  _inherits(Hero, _Phaser$Sprite);

  function Hero(game, x, y) {
    _classCallCheck(this, Hero);

    var _this = _possibleConstructorReturn(this, (Hero.__proto__ || Object.getPrototypeOf(Hero)).call(this, game, x, y, 'hero'));

    _this.invincible = false;
    _this.hurt = false;
    _this.anchor.set(0.5, 0.5);
    // physics properties
    _this.game.physics.enable(_this);
    _this.body.collideWorldBounds = true;
    // animations
    _this.animations.add('stop', [0]);
    _this.animations.add('run-right', [1, 2], 8, true);
    _this.animations.add('run-left', [1, 2], 8, true);
    _this.animations.add('jump', [4, 5, 6, 7], 12, true);
    _this.animations.add('die', [8]);
    _this.animations.add('hurt', [9]); // 12fps no loop
    _this.animations.play('stop');
    return _this;
  }

  _createClass(Hero, [{
    key: 'move',
    value: function move(direction) {
      // guard
      if (this.isFrozen) {
        return;
      }
      if (this.hurt) {
        if (this.body.velocity.x > 0) {
          this.body.velocity.x = 100;
          this.body.velocity.y = -100;
        } else {
          this.body.velocity.x = -100;
          this.body.velocity.y = -100;
        }
      }
      this.body.velocity.x = direction * 200;
      // update image flipping & animations
      if (this.body.velocity.x < 0) {
        this.scale.x = -1;
      } else if (this.body.velocity.x > 0) {
        this.scale.x = 1;
      }
    }
  }, {
    key: 'jump',
    value: function jump(springSpeed) {
      var canJump = this.body.touching.down && this.alive && !this.isFrozen && !this.hurt;
      var JUMP_SPEED = 550;
      if (canJump || this.isBoosting) {
        this.body.velocity.y = -springSpeed || -JUMP_SPEED;
        this.isBoosting = true;
      }
      return canJump;
    }
  }, {
    key: 'stopJumpBoost',
    value: function stopJumpBoost() {
      this.isBoosting = false;
    }
  }, {
    key: 'bounce',
    value: function bounce() {
      this.body.velocity.y = -200;
    }
  }, {
    key: 'injure',
    value: function injure() {
      var _this2 = this;

      this.invincible = true;
      this.hurt = true;
      setTimeout(function () {
        _this2.hurt = false;
      }, 500);
      setTimeout(function () {
        _this2.invincible = false;
      }, 2000);
    }
  }, {
    key: 'update',
    value: function update() {
      // update sprite animation, if it needs changing
      var animationName = this._getAnimationName();
      if (this.animations.name !== animationName) {
        this.animations.play(animationName);
      }
    }
  }, {
    key: 'freeze',
    value: function freeze() {
      this.body.enable = false;
      this.isFrozen = true;
    }
  }, {
    key: 'die',
    value: function die() {
      var _this3 = this;

      this.alive = false;
      this.body.enable = false;
      this.animations.play('die').onComplete.addOnce(function () {
        setTimeout(function () {
          _this3.kill();
        }, 750);
      });
    }
  }, {
    key: '_getAnimationName',
    value: function _getAnimationName() {
      var name = 'stop'; // default animation
      if (!this.alive) {
        name = 'die';
      } else if (this.isFrozen) {
        name = 'stop';
      } else if (this.hurt) {
        name = 'hurt';
      } else if (this.body.velocity.y < 0 || this.body.velocity.y > 0) {
        name = 'jump';
      } else if (this.body.velocity.x > 0 && this.body.touching.down) {
        name = 'run-right';
      } else if (this.body.velocity.x < 0 && this.body.touching.down) {
        name = 'run-left';
      }
      return name;
    }
  }]);

  return Hero;
}(_phaser2.default.Sprite);

exports.default = Hero;


//////////////////
// WEBPACK FOOTER
// ./src/sprites/Hero.js
// module id = 339
// module chunks = 0